export default "__VITE_ASSET__eee665bb__"